export default __webpack_public_path__ + "static/media/RH.03c3eeaa.svg";